import { Box, Columns, Column, Stack } from 'braid-design-system';

import { Display } from 'src/libs/Display';
import { Modal } from 'src/libs/Modal';

import * as styles from './FreemiumModalBase.css';

interface FreemiumModalProps {
  close: () => void;
  titleId: string;
  content: React.ReactNode;
  isOpen: boolean;
}

export const FreemiumModal = ({
  close,
  titleId,
  content,
  isOpen,
}: FreemiumModalProps) => (
  <Modal isOpen={isOpen} titleId={titleId} close={close}>
    <Box borderRadius="large" overflow="hidden">
      <Display mobile>
        <Stack space="none">
          <Box
            component="img"
            role="img"
            style={{
              height: 'auto',
              width: '100%',
              backgroundColor: '#051A49',
            }}
            src="https://seekcdn.com/cm-ui/images/FreemiumMobileHeader.png"
          />
          <Box padding="medium">{content}</Box>
        </Stack>
      </Display>
      <Display tablet desktop>
        <Columns space="none">
          <Column width="3/5">
            <Box
              padding="large"
              height="full"
              display="flex"
              alignItems="center"
            >
              {content}
            </Box>
          </Column>
          <Column>
            <Box className={styles.freemiumImage} />
          </Column>
        </Columns>
      </Display>
    </Box>
  </Modal>
);
